import Xuron from "../img/xuron_logo_tm_orange_large_png.png";
import { useTranslation } from "react-i18next";
import { ButtonComponent } from "../components/ui/buttonComponent";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex items-center w-full h-full justify-center">
      <div className="w-fit h-fit p-4 flex flex-col gap-4">
        <img className="w-[300px] mx-auto" src={Xuron} />
        <h1 className="uppercase text-[50px] font-semibold text-center">{t("not_found")}</h1>
        <ButtonComponent className="uppercase w-fit self-center" onClick={() => navigate("/home")}>
          {t("go_home")}
        </ButtonComponent>
      </div>
    </div>
  );
};

export default NotFound;
